import { Starter } from '../../../starters/types/StartersTypes';
import { Telemetry } from '../../../commonInfra/services/Telemetry';
import { StarterClicked, StartersDialogClickSourceOptions, StartersDropdownConnectionTypeChanged, StarterWorkbookCreationClicked, StarterWorkbookCreationSourceOptions, TelemetryEvents } from '../TelemetryEvents';

export type StartersTelemertyOptions = Telemetry;

export const starterClickedTelemetryEvent = (starter: Starter, selectedStarterIndex: number, source: StartersDialogClickSourceOptions) => {
    Telemetry.sendEvent<StarterClicked>({
        connectionType: starter.connectionType.displayName,
        selectedStarterIndex,
        source,
        starterId: starter.id,
        starterName: starter.name,
        type: TelemetryEvents.StarterClicked,
    });
};

export const StartersDropdownConnectionTypeChangeddTelemetryEvent = (connectionType: string) => {
    Telemetry.sendEvent<StartersDropdownConnectionTypeChanged>({
        connectionType,
        type: TelemetryEvents.StartersDropdownConnectionTypeChanged,
    });
};

export const StarterWorkbookCreationClickedTelemtryEvent = (source: StarterWorkbookCreationSourceOptions, starter: Starter, withSampleData: boolean) => {
    Telemetry.sendEvent<StarterWorkbookCreationClicked>({
        connectionType: starter.connectionType.displayName,
        source,
        starterId: starter.id,
        starterName: starter.name,
        type: TelemetryEvents.StarterWorkbookCreationClicked,
        withSampleData,
    });
};
